// extracted by mini-css-extract-plugin
export default {"root":"SelectedMessagesPrint_root__yzJZQ","page-break":"SelectedMessagesPrint_page-break__6rbr2"};